"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.recursiveGetVariableGroupsByStepId = exports.extractWorkspaceId = exports.extractComponentContentVariables = exports.getComponents = exports.doesNodeContainContentButNoWeblink = exports.doesNodeContainWeblink = exports.doCustomValidation = exports.determineGroupType = exports.determineGroupIcon = exports.validateStepName = exports.addNewBranch = exports.addNewNodeInBetween = exports.addNewNode = exports.setCollectResponseCaptureForNode = exports.createNode = exports.doesNodeHaveLinkContent = exports.doesNodeHaveMessageContent = exports.doesNodeHaveChildren = exports.deleteSelectedBranch = exports.deleteAllChildren = exports.deleteSelectedNodeWithDepth = exports.deleteSelectedNode = exports.deleteChild = exports.replaceNodeById = exports.findFirstMatchingNode = exports.findChildrenById = exports.findParentById = exports.findNodeById = exports.findNodes = exports.SEND_SMS_COLLECT_RESPONSES_VARIABLES = void 0;
/* eslint-disable no-else-return */
/* eslint-disable no-param-reassign */
/* eslint-disable no-use-before-define */
/* eslint-disable no-case-declarations */
/* eslint-disable max-params */
/* eslint-disable no-unused-expressions */
/* eslint-disable max-lines */
const workflow_definition_1 = require("@whispir/workflow-definition");
const workflow_factory_1 = require("@whispir/workflow-factory");
const static_1 = __importDefault(require("./static"));
const templates_1 = require("./templates");
const RANDOM_FACTOR = 10000;
const { SEND_WEBFORM, SEND_EMAIL, SEND_SMS, EXPRESSION, TIME, ON_SMS_REPLY, ON_WEBFORM_REPLY, } = workflow_factory_1.ACTION_TYPES;
const { TRIGGER } = workflow_factory_1.STEP_TYPES;
const { EMAIL, SMS } = workflow_factory_1.MESSAGE_TYPES;
const cloneDeep = (item) => JSON.parse(JSON.stringify(item));
const SEND_SMS_COLLECT_RESPONSES_VARIABLES = (stepId) => [
    {
        type: 'Recipient',
        variableId: `${stepId}-internal-recipient-id`,
        variableName: 'Recipient',
        variableType: 'recipient',
    },
    {
        type: 'Text',
        variableId: `${stepId}-internal-recipient-firstname`,
        variableName: 'Recipient: First Name',
        variableType: 'string',
    },
    {
        type: 'Text',
        variableId: `${stepId}-internal-recipient-lastname`,
        variableName: 'Recipient: Last Name',
        variableType: 'string',
    },
    {
        type: 'PhoneNumber',
        variableId: `${stepId}-internal-recipient-mobilephone1`,
        variableName: 'Recipient: Phone No.',
        variableType: 'string',
    },
    {
        type: 'EmailAddress',
        variableId: `${stepId}-internal-recipient-emailaddress1`,
        variableName: 'Recipient: Email',
        variableType: 'string',
    },
    {
        type: 'Date',
        variableId: `${stepId}-internal-message-timestamp`,
        variableName: 'Message: Time Sent',
        variableType: 'date',
    },
];
exports.SEND_SMS_COLLECT_RESPONSES_VARIABLES = SEND_SMS_COLLECT_RESPONSES_VARIABLES;
const SEND_WEBFORM_COLLECT_RESPONSES_VARIABLES = (stepId) => [
    {
        type: 'Recipient',
        variableId: `${stepId}-internal-recipient-id`,
        variableName: 'Recipient',
        variableType: 'recipient',
    },
    {
        type: 'Text',
        variableId: `${stepId}-internal-recipient-firstname`,
        variableName: 'Recipient: First Name',
        variableType: 'string',
    },
    {
        type: 'Text',
        variableId: `${stepId}-internal-recipient-lastname`,
        variableName: 'Recipient: Last Name',
        variableType: 'string',
    },
    {
        type: 'PhoneNumber',
        variableId: `${stepId}-internal-recipient-mobilephone1`,
        variableName: 'Recipient: Phone No.',
        variableType: 'string',
    },
    {
        type: 'EmailAddress',
        variableId: `${stepId}-internal-recipient-emailaddress1`,
        variableName: 'Recipient: Email',
        variableType: 'string',
    },
    {
        type: 'Date',
        variableId: `${stepId}-internal-message-timestamp`,
        variableName: 'Message: Time Sent',
        variableType: 'date',
    },
];
const COLLECT_RESPONSES_ACTION_TYPES = [SEND_SMS, SEND_WEBFORM];
const generateStepId = () => Math.floor(Math.random() * RANDOM_FACTOR);
function findNodes(currentNode, predicate) {
    const nodes = [];
    if (predicate(currentNode)) {
        nodes.push(currentNode);
    }
    if (currentNode && currentNode.next) {
        currentNode.next.forEach((node) => {
            const results = findNodes(node, predicate);
            results.length && nodes.push(...results);
        });
    }
    return nodes;
}
exports.findNodes = findNodes;
const findNodeById = (rootNode, id) => findNodes(rootNode, (node) => node.id === id)[0];
exports.findNodeById = findNodeById;
const findParentById = (rootNode, id) => findNodes(rootNode, (node) => {
    if (node && node.next && node.next.length) {
        const foundChild = node.next.some(({ id: nodeId }) => nodeId === id);
        return foundChild;
    }
    return false;
})[0];
exports.findParentById = findParentById;
const findChildrenById = (rootNode, id) => {
    const foundNode = (0, exports.findNodeById)(rootNode, id);
    if (foundNode) {
        // If collecting responses, we don't look at the immediate children, we look at children of the ON_REPLY node.
        if (COLLECT_RESPONSES_ACTION_TYPES.includes(foundNode.action) &&
            foundNode.data.collectResponses) {
            return foundNode.next[0].next;
        }
        else {
            return foundNode.next;
        }
    }
    else {
        return null;
    }
};
exports.findChildrenById = findChildrenById;
function findFirstMatchingNode(root, predicate) {
    // using BFS traverse the node tree
    let queue = [root];
    while (queue.length) {
        const currentNode = queue.shift();
        // found match, early return to prevent from traversing the rest of tree
        if (predicate(currentNode))
            return currentNode;
        const { next } = currentNode;
        if (next) {
            queue = queue.concat(next);
        }
    }
    return null;
}
exports.findFirstMatchingNode = findFirstMatchingNode;
function replaceNodeById(root, id, newNode) {
    const res = findFirstMatchingNode(root, ({ id: nodeId }) => nodeId === id);
    res &&
        Object.keys(newNode).forEach((key) => {
            res[key] = newNode[key];
        });
}
exports.replaceNodeById = replaceNodeById;
function deleteChild(parentNode, index) {
    const { next } = parentNode;
    // if there are more than 1 child,
    if (next && next.length > 1) {
        const remainingChildren = next.filter((_, i) => i !== index);
        return remainingChildren;
    }
    else {
        // If there is only 1 child, we delete all children.
        // null represents the value that will be assigned to `node.next`
        return null;
    }
}
exports.deleteChild = deleteChild;
function deleteSelectedNode(nodeId, currentStructure, index) {
    const structure = cloneDeep(currentStructure);
    const rootNode = structure[0];
    const parentNode = (0, exports.findParentById)(rootNode, nodeId);
    const childrenNodes = (0, exports.findChildrenById)(rootNode, nodeId);
    // If there are no children nodes, just remove the current node.
    if (!childrenNodes) {
        // If the parent has multiple children, replace the node to be deleted with
        // an empty node.
        if (parentNode.next.length > 1) {
            const [empty] = (0, templates_1.emptyTemplate)(nodeId);
            parentNode.next[index] = empty;
        }
        // If current node is the parent's only child, then we need to set null, coz that's just how it is. :/
        else {
            parentNode.next = null;
        }
    }
    else {
        // Otherwise, parent has children.
        // `deleteChild` will return null if only 1 child exists for deletion,
        // so we set the `parentNodeChildrenAfterDeletion` to be an empty array
        // if the value returned is falsy, so that the array spread later does not
        // spread on null.
        //
        // In the future, we probably want to update the model utils to set the
        // `next` property to be an empty array when no children exist, to remove
        // these types of fallbacks and to implement better functional programming
        // with rest spreads.
        const parentNodeChildrenAfterDeletion = deleteChild(parentNode, index) || [];
        parentNode.next = [...childrenNodes, ...parentNodeChildrenAfterDeletion];
    }
    // Finally, after performing modifications on the parent, update the
    // workflow definition with the modified parent
    replaceNodeById(structure[0], parentNode.id, parentNode);
    return structure;
}
exports.deleteSelectedNode = deleteSelectedNode;
function deleteSelectedNodeWithDepth(nodeId, currentStructure, index) {
    let parentNode = [];
    const structure = currentStructure;
    const defaultRootNode = static_1.default[0].structure;
    if (nodeId) {
        // store parent node
        parentNode = (0, exports.findParentById)(structure[0], nodeId);
        if (parentNode) {
            // return null or empty array
            const children = deleteChild(parentNode, index);
            parentNode.next = children;
        }
        else {
            // if parent node not found, meaning it is the root node, replace it with default
            return [defaultRootNode[0]];
        }
    }
    return structure;
}
exports.deleteSelectedNodeWithDepth = deleteSelectedNodeWithDepth;
function deleteAllChildren(nodeId, currentStructure) {
    let parentNode = [];
    const structure = currentStructure;
    if (nodeId || nodeId === 0) {
        // store parent node
        parentNode = (0, exports.findNodeById)(structure[0], nodeId);
        parentNode.next = null;
    }
    return structure;
}
exports.deleteAllChildren = deleteAllChildren;
function deleteSelectedBranch(nodeId, currentStructure, index) {
    let parentNode = [];
    const structure = cloneDeep(currentStructure);
    const defaultRootNode = static_1.default[0].structure;
    if (nodeId) {
        // store parent node
        parentNode = (0, exports.findParentById)(structure[0], nodeId);
        let newChildren = parentNode.next === null ? [] : parentNode.next;
        if (parentNode.type === TRIGGER &&
            parentNode.next.every(({ type }) => type === 'empty')) {
            newChildren = null;
        }
        else {
            newChildren.splice(index, 1);
        }
        parentNode.next = newChildren;
    }
    else {
        // if parent node not found, meaning it is the root node, replace it with default
        replaceNodeById(structure[0], nodeId, defaultRootNode[0]);
    }
    return structure;
}
exports.deleteSelectedBranch = deleteSelectedBranch;
function doesNodeHaveChildren(node) {
    /**
     * Short-circuit for nodes that can have response collection enabled.
     * When we are collecting responses, we actually want to look at the children
     * of the send-message step (the on-reply and on-no-reply nodes) to see if they have children.
     */
    if (COLLECT_RESPONSES_ACTION_TYPES.includes(node.action) &&
        node.data.collectResponses) {
        return !!node.next.find((v) => !!(v.next && v.next.length > 0));
    }
    return !!(node.next && node.next.length > 0);
}
exports.doesNodeHaveChildren = doesNodeHaveChildren;
function doesNodeHaveMessageContent(node) {
    switch (node.data.message.type) {
        case SMS:
            return node.data.message.content && node.data.message.content.body !== '';
        case EMAIL:
            return node.data.message.content && node.data.link.content.components
                ? node.data.message.content.components.length !== 0
                : !!node.data.message.content.contentId;
        default:
            return false;
    }
}
exports.doesNodeHaveMessageContent = doesNodeHaveMessageContent;
function doesNodeHaveLinkContent(node) {
    return node.data.link && node.data.link.content.components
        ? node.data.link.content.components.length !== 0
        : !!node.data.link.content.contentId;
}
exports.doesNodeHaveLinkContent = doesNodeHaveLinkContent;
function createNode(actionType, newId, structure, workspaceId) {
    switch (actionType) {
        case SEND_SMS:
            return (0, templates_1.sendSmsTemplate)(newId, workspaceId, structure);
        case SEND_EMAIL:
            return (0, templates_1.sendEmailTemplate)(newId, workspaceId, structure);
        case TIME:
            return (0, templates_1.timeTemplate)(newId);
        case EXPRESSION:
            return (0, templates_1.expressionTemplate)(newId);
        case 'split':
            return [...(0, templates_1.emptyTemplate)(newId), ...(0, templates_1.emptyTemplate)(newId + 1)];
        case SEND_WEBFORM:
            const node = (0, templates_1.sendWebformTemplate)(newId, workspaceId, structure);
            setCollectResponseCaptureForNode(node[0], {
                days: 1,
                hours: 0,
                minutes: 0,
            }, false);
            return node;
        default:
            throw new Error(`ActionType: ${actionType} is not a valid action type`);
    }
}
exports.createNode = createNode;
const collectResponsesConfigMap = {
    [SEND_SMS]: {
        output: exports.SEND_SMS_COLLECT_RESPONSES_VARIABLES,
        onResponseTemplate: templates_1.onSmsResponseTemplate,
        onNoResponseTemplate: templates_1.onSmsNoResponseTemplate,
        onReplyNodeName: ON_SMS_REPLY,
    },
    [SEND_WEBFORM]: {
        output: SEND_WEBFORM_COLLECT_RESPONSES_VARIABLES,
        onResponseTemplate: templates_1.onWebformResponseTemplate,
        onNoResponseTemplate: templates_1.onWebformNoResponseTemplate,
        onReplyNodeName: ON_WEBFORM_REPLY,
    },
};
function setCollectResponseCaptureForNode(node, duration, preserveLeftBranch) {
    if (!COLLECT_RESPONSES_ACTION_TYPES.includes(node.action)) {
        throw new Error(`Only ${JSON.stringify(COLLECT_RESPONSES_ACTION_TYPES)} can have collect responses, this was ${node.action}`);
    }
    const configItems = collectResponsesConfigMap[node.action];
    if (duration) {
        // If not already collecting responses
        if (!node.data.collectResponses) {
            node.data.collectResponses = true;
            node.variables = Object.assign(Object.assign({}, node.variables), { output: configItems.output(node.id) });
            const onResponseNode = configItems.onResponseTemplate(generateStepId(), node, duration);
            const onNoResponseNode = configItems.onNoResponseTemplate(generateStepId(), node, duration);
            if (node.next) {
                onResponseNode[0].next = node.next;
            }
            node.next = [...onResponseNode, ...onNoResponseNode];
        }
        // If already collecting responses - just update the collect reponses duration
        else {
            node.next[0].data.collectResponses.duration = duration;
            node.next[1].data.collectResponses.duration = duration;
        }
    }
    else {
        node.data.collectResponses = false;
        node.variables.output = []; // Be aware that we are clobbering the variables. In future, we might want to selectively add/remove.
        const [onResponseNode] = node.next; // on-sms-reply node is always the first node.
        if (onResponseNode.next) {
            if (onResponseNode.action !== configItems.onReplyNodeName) {
                throw new Error(`The first node of a collect responses ${node.action} was not a ${configItems.onReplyNodeName} node`);
            }
            const childNodes = onResponseNode.next;
            if (preserveLeftBranch) {
                node.next = [...childNodes];
            }
            else {
                node.next = null;
            }
        }
        else {
            node.next = null;
        }
    }
}
exports.setCollectResponseCaptureForNode = setCollectResponseCaptureForNode;
function addNewNode(previousNode, actionType, currentStructure, workspaceId) {
    const structure = currentStructure;
    const newId = generateStepId();
    const { id } = previousNode;
    const newNode = createNode(actionType, newId, structure, workspaceId);
    const previousNodeIsStart = previousNode && previousNode.type === TRIGGER;
    const previousNodeIsEmpty = previousNode && previousNode.type === 'empty';
    if (!previousNodeIsEmpty || previousNodeIsStart) {
        const node = (0, exports.findNodeById)(structure[0], id);
        node.next = newNode;
    }
    if (previousNodeIsEmpty) {
        if (actionType !== 'split') {
            replaceNodeById(structure[0], id, newNode[0]);
        }
        else {
            // previous node is a split and action type/new node injected is a split
            const matchingNode = findFirstMatchingNode(structure[0], ({ id: nodeId }) => nodeId === id);
            matchingNode.next = newNode;
        }
    }
    return structure;
}
exports.addNewNode = addNewNode;
function addNewNodeInBetween(previousNode, actionType, currentStructure, index, isDirectlyFollowedByABranch, workspaceId) {
    const structure = currentStructure;
    const newId = generateStepId();
    const parentNode = previousNode;
    const selectedPos = parentNode.next;
    const newNode = createNode(actionType, newId, structure, workspaceId);
    // handling node insertion directly after a braching system
    if (!isDirectlyFollowedByABranch && selectedPos && selectedPos.length >= 2) {
        const childNode = parentNode.next[index];
        newNode[0].next = [childNode];
        const [newNodeFirstObj] = newNode;
        parentNode.next[index] = newNodeFirstObj;
    }
    // handling node insertion after a step
    else if (actionType === 'split') {
        const childNode = parentNode.next;
        const [childNodeFirstObj] = childNode;
        const [splitFirstChild] = newNode;
        // Assign reference of the first child of the split component to equal next node
        Object.keys(childNodeFirstObj).forEach((key) => {
            splitFirstChild[key] = childNodeFirstObj[key];
        });
        parentNode.next = newNode;
    }
    else if (actionType === SEND_WEBFORM) {
        const [onWebformReplyBranch] = newNode[0].next;
        onWebformReplyBranch.next = parentNode.next;
        parentNode.next = newNode;
    }
    else {
        const childNode = parentNode.next;
        newNode[0].next = childNode;
        parentNode.next = newNode;
    }
    return structure;
}
exports.addNewNodeInBetween = addNewNodeInBetween;
function addNewBranch(previousNode, currentStructure) {
    const newId = generateStepId();
    const { id } = previousNode;
    const newNode = (0, templates_1.emptyTemplate)(newId);
    const newStructure = currentStructure;
    const node = (0, exports.findNodeById)(newStructure[0], id);
    const { next } = node;
    if (next)
        node.next = [...next, ...newNode];
    return newStructure;
}
exports.addNewBranch = addNewBranch;
/**
 * This function validates that a step name is unique
 */
const validateStepName = (stepName, definition) => {
    let stepNameIsValid = true;
    (0, workflow_definition_1.callbackStepsViaDefinitionRecursionDFS)({
        step: (0, workflow_definition_1.getRootStep)(definition),
        definition,
        stepCallback: ({ data: { stepName: currentStepName } }) => {
            if (currentStepName === stepName) {
                stepNameIsValid = false;
            }
        },
    });
    return stepNameIsValid;
};
exports.validateStepName = validateStepName;
const determineGroupIcon = (nodeAction) => {
    switch (nodeAction) {
        case SEND_SMS:
            return 'smsMessageVariables';
        case SEND_EMAIL:
            return 'emailMessageVariables';
        case ON_SMS_REPLY:
            return 'onReplyVariables';
        case 'form':
            return 'formVariables';
        default:
            return null;
    }
};
exports.determineGroupIcon = determineGroupIcon;
const determineGroupType = (node) => {
    if (node.type === TRIGGER) {
        const [triggerObj] = node.data.triggers;
        return (0, exports.determineGroupIcon)(triggerObj.type);
    }
    return (0, exports.determineGroupIcon)(node.action);
};
exports.determineGroupType = determineGroupType;
const doCustomValidation = (node) => {
    const { action } = node;
    if (action !== SEND_WEBFORM) {
        // Only send-webform has custom validation at this point.
        return null;
    }
    if ((0, exports.doesNodeContainContentButNoWeblink)(node)) {
        return 'Web Form Link Missing';
    }
    return null;
};
exports.doCustomValidation = doCustomValidation;
const doesNodeContainWeblink = (node) => {
    const { data } = node;
    const { message } = data;
    if (!message) {
        return false;
    }
    if (message.type === 'sms') {
        const foundWeblink = message.content.body.includes('<span data-systemvariable="web_link">');
        return foundWeblink;
    }
    else if (message.type === 'email') {
        const foundWebLink = message.content.components.some((component) => component.properties.some((property) => {
            if (!property.value) {
                return false;
            }
            return (property.value.includes('<span data-systemvariable="web_link">') ||
                property.value.includes('"variableName":"web_link"'));
        }));
        return foundWebLink;
    }
    return false;
};
exports.doesNodeContainWeblink = doesNodeContainWeblink;
/**
 * Note that this one is an inverse of the one above! - true = no weblink.
 */
const doesNodeContainContentButNoWeblink = (node) => {
    const { data } = node;
    const { message } = data;
    if (!message) {
        return false;
    }
    if (message.type === 'sms') {
        if (message.content.body.length === 0) {
            return false;
        }
    }
    else if (message.type === 'email') {
        if ((message.content.components && message.content.components.length === 0) ||
            !!message.content.contentId) {
            return false;
        }
    }
    const hasWeblink = (0, exports.doesNodeContainWeblink)(node);
    return !hasWeblink;
};
exports.doesNodeContainContentButNoWeblink = doesNodeContainContentButNoWeblink;
const getComponents = ({ nodeData, channelType }) => {
    switch (channelType) {
        case 'sms':
            return [];
        case 'email':
            const { message: { content: { components: messageComponents }, }, } = nodeData;
            return messageComponents;
        case 'web':
        case 'webform':
            if (nodeData.link) {
                const { link: { content: { components: webComponents }, }, } = nodeData;
                return webComponents;
            }
            return [];
        case 'form':
            const { form: { components: formComponents }, } = nodeData;
            return formComponents;
        default:
            throw new Error(`Channel type not found: ${channelType}`);
    }
};
exports.getComponents = getComponents;
const getPropertyValue = ({ properties, propName }) => {
    const res = properties.find(({ name }) => name === propName);
    return res;
};
const extractComponentContentVariables = ({ components = [] }) => 
// Reduce in this scenario is just map + filter
components.reduce((acc, cur) => {
    const { type, properties } = cur;
    const uniqueName = getPropertyValue({ properties, propName: 'uniqueName' });
    const options = getPropertyValue({ properties, propName: 'optionsPicker' });
    const variableName = getPropertyValue({ properties, propName: 'label' });
    if (uniqueName && options) {
        return [
            ...acc,
            {
                type,
                variableId: uniqueName.value,
                variableName: variableName.value,
                variableType: uniqueName.valueType,
                options: options.value,
            },
        ];
    }
    else if (uniqueName) {
        return [
            ...acc,
            {
                type,
                variableId: uniqueName.value,
                variableName: variableName.value,
                variableType: uniqueName.valueType,
            },
        ];
    }
    return acc;
}, []);
exports.extractComponentContentVariables = extractComponentContentVariables;
const extractWorkspaceId = ({ definition }) => {
    let workspaceId = '';
    const sendMessageActionTypes = [SEND_WEBFORM, SEND_EMAIL, SEND_SMS];
    (0, workflow_definition_1.callbackStepsViaDefinitionRecursionDFS)({
        step: (0, workflow_definition_1.getRootStep)(definition),
        definition,
        stepCallback: ({ action, data }) => {
            if (sendMessageActionTypes.includes(action)) {
                workspaceId = data.workspaceId;
            }
        },
    });
    return workspaceId;
};
exports.extractWorkspaceId = extractWorkspaceId;
// This function returns a set of updated variable groups for the new variable menu selecetor.
const recursiveGetVariableGroupsByStepId = (currentNode, nodeId, accumulatedVariables) => {
    if (currentNode.id === nodeId) {
        return accumulatedVariables;
    }
    if (currentNode.next) {
        const transformedVars = currentNode.variables.output.map((variable) => (Object.assign(Object.assign({}, variable), { stepId: currentNode.id, groupName: currentNode.data.stepName, groupType: (0, exports.determineGroupType)(currentNode) })));
        const newAccumulatedVariables = [
            ...accumulatedVariables,
            {
                groupName: currentNode.data.stepName,
                groupType: (0, exports.determineGroupType)(currentNode),
                variables: transformedVars,
            },
        ];
        const variablesToReturn = [];
        currentNode.next.forEach((node) => {
            variablesToReturn.push(...this.recursiveGetVariableGroupsByStepId(node, nodeId, newAccumulatedVariables));
        });
        return variablesToReturn;
    }
    return [];
};
exports.recursiveGetVariableGroupsByStepId = recursiveGetVariableGroupsByStepId;
//# sourceMappingURL=modelUtils.js.map